import React from "react";
import { DS } from "../theme-default";

/**
 * Segmented filter control — a row of pill toggles for a small fixed set of
 * mutually exclusive states (the pattern used for status filters in most
 * issue trackers/mail clients).
 *
 * Props:
 *  - options: [{ value, label }]
 *  - value: currently selected value
 *  - onChange(value)
 */
export default function SegmentedFilter({ options, value, onChange }) {
  return (
    <div
      role="group"
      aria-label="Filtru"
      style={{
        display: "inline-flex",
        flexWrap: "wrap",
        gap: 6,
        verticalAlign: "middle",
        fontFamily: DS.font,
      }}
    >
      {options.map((option) => {
        const isActive = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={isActive}
            onClick={() => {
              if (!isActive) {
                onChange(option.value);
              }
            }}
            style={{
              border: "1px solid " + (isActive ? DS.primary : DS.borderStrong),
              backgroundColor: isActive ? DS.primaryTint : DS.surface,
              color: isActive ? DS.primary : DS.textSecondary,
              fontWeight: isActive ? 600 : 500,
              fontSize: "14px",
              fontFamily: DS.font,
              borderRadius: 999,
              padding: "7px 16px",
              cursor: isActive ? "default" : "pointer",
              lineHeight: 1.4,
              transition: "background-color 120ms ease, color 120ms ease, border-color 120ms ease",
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.backgroundColor = DS.bg;
                e.currentTarget.style.color = DS.ink;
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.backgroundColor = DS.surface;
                e.currentTarget.style.color = DS.textSecondary;
              }
            }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
